<script>
import 'floating-vue/dist/style.css'
import {
  Tooltip
} from 'floating-vue'

export default {
  components: {
    'floating-tooltip': Tooltip
  }
}
</script>

<template>
  <floating-tooltip
    v-bind="$attrs"
    v-on="$attrs"
  >
    <slot />

    <template #popper>
      <slot name="popper" />
    </template>
  </floating-tooltip>
</template>

<style>
.v-popper--theme-tooltip .v-popper__inner {
  background: theme('colors.white');
  color: theme('colors.black');
  padding-bottom: theme('padding.3');
  @apply shadow-lg;
  @apply border;
  @apply border-gray-400;
  @apply border-b-0;
}

.v-popper--theme-tooltip .v-popper__arrow-outer {
  border-color: theme('colors.white');
}

.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-outer {
  border-color: theme('colors.gray.400');
}

.v-popper--theme-tooltip.v-popper__popper--show-from .v-popper__wrapper {
  opacity: 0;
}

.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=bottom].v-popper__popper--show-from .v-popper__wrapper {
  transform: translateY(5px);
}

.v-popper--theme-tooltip.v-popper__popper--show-to .v-popper__wrapper {
  transform: translateY(0);
  transition: opacity 0.1s ease-out, transform 0.1s ease-out;
}

.v-popper--theme-tooltip.v-popper__popper--hidden-from .v-popper__wrapper {
  transition: opacity 0.1s ease-out, transform 0.1s ease-out;
  opacity: 1
}

.v-popper--theme-tooltip.v-popper__popper--hide-to .v-popper__wrapper {
  transition: opacity 0.1s ease-out, transform 0.1s ease-out;
  opacity: 1;
}

.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=bottom].v-popper__popper--hide-to .v-popper__wrapper {
  transform: translateY(5px);
}
</style>
